module.exports = __webpack_public_path__ + "img/style_7_en.a3610069.jpeg";